import E, { stdSerializers as a, symbols as T } from "pino";
import { z as v } from "zod";
const m = ["debug", "info", "warn", "error", "fatal", "audit"], f = v.enum(m), u = !process.env.NODE_ENV || process.env.NODE_ENV === "production", N = process.env.NEXT_PHASE === "phase-production-build", L = "process", _ = /[/\\]apps[/\\]web$/, O = "node_modules/pino-opentelemetry-transport/lib/pino-opentelemetry-transport.js", g = () => globalThis[L], b = () => `${g().cwd().replace(_, "")}/${O}`, n = () => {
  let e = "info";
  u && (e = "warn"), N && (e = "error");
  const o = process.env.LOG_LEVEL, t = f.safeParse(o);
  return t.success && (e = t.data), e;
}, R = {
  level: n(),
  serializers: {
    err: a.err,
    req: a.req,
    res: a.res
  },
  customLevels: {
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60,
    audit: 90
  },
  useOnlyCustomLevels: !0,
  timestamp: !0,
  name: "formbricks"
}, h = () => {
  const e = process.env.NEXT_RUNTIME === "edge", o = process.env.NEXT_RUNTIME === "nodejs" && process.env.OTEL_LOGS_ENABLED === "1" && !!process.env.OTEL_EXPORTER_OTLP_ENDPOINT, t = process.env.OTEL_SERVICE_NAME ?? "formbricks", p = process.env.npm_package_version ?? "0.0.0", d = () => ({
    target: b(),
    options: {
      loggerName: t,
      serviceVersion: p,
      resourceAttributes: {
        "service.name": t,
        "service.version": p,
        "deployment.environment": process.env.ENVIRONMENT ?? process.env.NODE_ENV ?? "development"
      }
    },
    level: n()
  }), i = {
    target: "pino-pretty",
    options: {
      colorize: !0,
      levelFirst: !0,
      translateTime: "SYS:standard",
      ignore: "pid,hostname,ip,requestId",
      customLevels: "trace:10,debug:20,info:30,warn:40,error:50,fatal:60,audit:90",
      useOnlyCustomProps: !0
    },
    level: n()
  };
  if (!u)
    return e ? void 0 : o ? { targets: [i, d()] } : { target: i.target, options: i.options };
  if (o)
    return { targets: [{
      target: "pino/file",
      options: { destination: 1 },
      // stdout
      level: n()
    }, d()] };
}, c = h(), I = c !== void 0 && "targets" in c, S = {
  ...R,
  transport: c,
  ...!I && {
    formatters: {
      level: (e) => ({ level: e })
    }
  }
}, r = E(S), P = (e) => {
  const o = e instanceof Error ? e.stack ?? e.message : String(e);
  g().stderr.write(`[logger] Pino transport error: ${o}
`);
}, A = (e) => {
  if (process.env.NEXT_RUNTIME !== "nodejs") return;
  e[T.streamSym]?.on?.("error", P);
};
A(r);
const w = {
  debug: r.debug.bind(r),
  info: r.info.bind(r),
  audit: r.audit.bind(r),
  warn: r.warn.bind(r),
  error: r.error.bind(r),
  fatal: r.fatal.bind(r)
}, y = {
  ...w,
  withContext: (e) => r.child(e),
  request: (e) => r.child({
    method: e.method,
    url: e.url
  })
}, l = y, s = (e, o) => {
  o && l.error(o, `Error during shutdown (${e})`), l.info({ event: e }, "Process is exiting"), r.flush();
}, M = () => {
  process.env.NEXT_RUNTIME === "nodejs" && (process.on("uncaughtException", (e) => {
    s("uncaughtException", e);
  }), process.on("unhandledRejection", (e) => {
    s("unhandledRejection", e);
  }), process.on("SIGTERM", () => {
    s("SIGTERM");
  }), process.on("SIGINT", () => {
    s("SIGINT");
  }));
};
if (process.env.NEXT_RUNTIME === "nodejs")
  try {
    M();
  } catch (e) {
    l.error(e, "Error attaching process event handlers");
  }
export {
  l as logger
};
